import React, { useState, useRef, useEffect } from "react";
import ExportProgress from "./ExportProgress";
import { Link } from "react-router-dom";
import { Row, Card, Col, Button, Modal, Container } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import { db } from "../../../../firebase";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
  collectionGroup,
  where,
  query,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import {
  setEvent,
  eventTmp,
  paymentPrivilages,
  orderList,
  colorList,
  statusList,
  typeList,
  PatientLinkInfo,
  PatientDropDownForm,
  PatientTextInfo,
} from "../../Booking/BookingUtils";

import { enrichCPAPSaleExport } from "./CPAPSaleUtils";

import orderFormFields from "../../Sales/orderFormFields";
import formFields from "../../Sales/formFields";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import * as XLSX from "xlsx";

import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import Toast from "../../../components/toast/SetToast";
import { connectStorageEmulator } from "firebase/storage";
import { ro } from "date-fns/locale";
import { use } from "react";

const serialNumberOptions = [
  "All",
  "Has serial number (CPAP Devices)",
  "No serial number (Accessories)",
];

const validateExportDates = (start, end) => {
  if (start == null || end == null) {
    throw new Error("Please select both start and end dates.");
  }
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  if (!Number.isFinite(startTime) || !Number.isFinite(endTime)) {
    throw new Error("Please select valid start and end dates.");
  }
  if (startTime > endTime) {
    throw new Error("The end date must be on or after the start date.");
  }
};

const requireExportOrders = (orders) => {
  if (!orders.length) {
    throw new Error("No sale orders match the selected range and filters.");
  }
};

const matchesSerialNumberFilter = (order, selection, isNewOrder = false) => {
  if (selection === "All") return true;

  const hasSerialNumber = isNewOrder
    ? (order.items || []).some(
        (item) =>
          item.productType === "CPAP" &&
          String(item.productSn == null ? "" : item.productSn).trim() !== "",
      )
    : String(order.productSn == null ? "" : order.productSn).trim() !== "";

  return selection === "Has serial number (CPAP Devices)"
    ? hasSerialNumber
    : !hasSerialNumber;
};

const CPAPSale = () => {
  const { currentUser } = useAuth();
  // console.log(formFields)
  // ...formFields[1].options
  const brandList = ["All", "Topson", "Philips"];
  const modelList = formFields[2].options;

  const getSaleList = orderFormFields.find(
    (fieldData) => fieldData.label == "Sales Representative",
  );
  const getActivityList = orderFormFields.find(
    (fieldData) => fieldData.label == "Activity",
  );
  const getStatusList = orderFormFields.find(
    (fieldData) => fieldData.label == "Status",
  );

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [newStartDate, setNewStartDate] = useState(null);
  const [newEndDate, setNewEndDate] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [exportProgress, setExportProgress] = useState(null);
  const [exportError, setExportError] = useState("");
  const exportInProgress = useRef(false);

  const runExport = async (action) => {
    if (exportInProgress.current) return;
    exportInProgress.current = true;
    setIsLoading(true);
    setExportError("");
    setExportProgress({ percent: 0, message: "Loading CPAP sale records..." });
    let active = true;
    // Ignore late parallel lookup completions after a failed export.
    const onProgress = (progress) => {
      if (active) setExportProgress(progress);
    };
    try {
      await action(onProgress);
      setExportProgress({ percent: 100, message: "Export ready. Download started." });
    } catch (error) {
      setExportProgress(null);
      setExportError(`Unable to export CPAP Sale: ${error.message || "Please try again."}`);
    } finally {
      active = false;
      exportInProgress.current = false;
      setIsLoading(false);
    }
  };

  const enrichExportOrders = async (orders, onProgress) => {
    let completed = 0;
    onProgress({ percent: 5, message: `Checking sale records: 0 / ${orders.length}` });
    return Promise.all(orders.map(async (order) => {
      const result = await enrichCPAPSaleExport(order.data());
      completed += 1;
      onProgress({
        percent: 5 + Math.floor((completed / orders.length) * 70),
        message: `Checking sale records: ${completed} / ${orders.length}`,
      });
      return result;
    }));
  };

  const [nodeList, setNodeList] = useState([]);
  const [nodeIdDocs, setNodeIdDocs] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [newCustomerList, setNewCustomerList] = useState([]);

  const [customerAllList, setCustomerAllList] = useState([]);

  const [saleList, setSaleList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const nodeRef = useRef();
  const customerRef = useRef();
  const saleRef = useRef();
  const activityRef = useRef();
  const statusRef = useRef();
  const brandRef = useRef();
  const modelRef = useRef();
  const serialNumberRef = useRef();

  const newNodeRef = useRef();
  const newCustomerRef = useRef();
  const newSaleRef = useRef();
  const newActivityRef = useRef();
  const newStatusRef = useRef();
  const newBrandRef = useRef();
  const newModelRef = useRef();
  const newSerialNumberRef = useRef();

  const yearRef = useRef();
  const monthRef = useRef();
  const startRef = useRef();
  const endRef = useRef();
  const nodeIGCRef = useRef();
  const customerIGCRef = useRef();
  const serialNumberIGCRef = useRef();

  const newYearRef = useRef();
  const newMonthRef = useRef();
  const newStartRef = useRef();
  const newEndRef = useRef();
  const newNodeIGCRef = useRef();
  const newCustomerIGCRef = useRef();
  const newSerialNumberIGCRef = useRef();

  useEffect(() => {
    fetchAnotherData();
  }, []);

  const fetchAnotherData = async () => {
    try {
      // Use Promise.all for parallel fetching
      const [nodesDocs] = await Promise.all([getDocs(collection(db, "nodes"))]);

      let allCustomers = [];
      let allnodeIdDocs = [];
      let allNodes;
      if (
        ["super_admin", "sale", "accountant"].includes(
          currentUser.roles[0],
        )
      ) {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      } else if (currentUser.roles[0] == "sleep_physician") {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      } else {
        // allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        const currentAdmin = await getDoc(
          doc(db, "admins", currentUser.displayName),
        );
        let nodeCode = currentAdmin.data().node;
        // Ensure `nodeCode` is always an array
        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : []; // Convert to array or set to empty
        }

        // Find matching nodes
        const node = nodesDocs.docs.filter((doc) =>
          nodeCode.includes(doc.data().nodecode),
        );

        allnodeIdDocs = node.map((doc) => doc.id);
        allNodes = node.map((doc) => doc.data().nodename);

        for (const id of allnodeIdDocs) {
          const customerDocs = await getDocs(
            collection(db, "nodes", id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      }
      setCustomerAllList(["All", ...allCustomers]);
      setCustomerList(["All", ...allCustomers[0]]);
      setNewCustomerList(["All", ...allCustomers[0]]);
      setNodeList(["All", ...allNodes]);
      setNodeIdDocs(["All", ...allnodeIdDocs]);

      setSaleList(["All", ...getSaleList.options]);
      setActivityList(["All", ...getActivityList.options]);
      setStatusList(["All", ...getStatusList.options]);
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const buildOldQuery = (
    borrowingsCollectionGroupRef,
    start,
    end,
    node,
    customer,
    sale,
    activity,
    status,
    brand,
  ) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    let queryConstraints = [];

    queryConstraints.push(orderBy("receiptDate"));

    const startDateTimestamp = Timestamp.fromDate(startDate);
    const endDateTimestamp = Timestamp.fromDate(endDate);

    queryConstraints.push(where("receiptDate", ">=", startDateTimestamp));
    queryConstraints.push(where("receiptDate", "<=", endDateTimestamp));

    if (node != "All") {
      queryConstraints.push(where("nodeRef", "==", node));
    }
    if (customer != "All") {
      queryConstraints.push(where("refCustomer", "==", customer));
    }
    if (sale != "All") {
      queryConstraints.push(where("sales", "==", sale));
    }
    if (activity != "All") {
      queryConstraints.push(where("activity", "==", activity));
    }
    if (status != "All") {
      queryConstraints.push(where("status", "==", status));
    }
    if (brand != "All") {
      if (brand == "Topson") {
        queryConstraints.push(
          where("productSn", ">=", "LC"),
          where("productSn", "<", "LC" + "\uf8ff"),
        );
      } else if (brand == "Philips") {
        queryConstraints.push(
          where("productSn", ">=", "J"),
          where("productSn", "<", "J" + "\uf8ff"),
        );
      }
    }
    // if (model != "All") {
    //   queryConstraints.push(where("model", "==", model));
    // }
    return query(borrowingsCollectionGroupRef, ...queryConstraints);
  };

  const getSaleValuesForQuery = (sale) => {
    if (!sale || sale === "All") return [];

    const cleanSale = sale.trim();

    // Example: "B.Sunisa" -> "Sunisa"
    const nameOnly = cleanSale.includes(".")
      ? cleanSale.split(".").slice(1).join(".")
      : cleanSale;

    // Example: "Sunisa" -> "B.Sunisa"
    const fullSale = saleList.find((item) => {
      const itemNameOnly = item.split(".").slice(1).join(".");
      return itemNameOnly === nameOnly || item === cleanSale;
    });
    // console.log("fullSale: ",fullSale)

    const values = [cleanSale];

    if (nameOnly && !values.includes(nameOnly)) {
      values.push(nameOnly);
    }

    if (fullSale && !values.includes(fullSale)) {
      values.push(fullSale);
    }
    console.log("values: ",values)
    return values;
  };

  const buildNewQuery = (
    borrowingsCollectionGroupRef,
    start,
    end,
    node,
    customer,
    sale,
    status,
  ) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    let queryConstraints = [];

    queryConstraints.push(orderBy("receiptDate"));

    const startDateTimestamp = Timestamp.fromDate(startDate);
    const endDateTimestamp = Timestamp.fromDate(endDate);

    queryConstraints.push(where("receiptDate", ">=", startDateTimestamp));
    queryConstraints.push(where("receiptDate", "<=", endDateTimestamp));

    if (node != "All") {
      queryConstraints.push(where("nodeRef", "==", node));
    }
    if (customer != "All") {
      queryConstraints.push(where("refCustomer", "==", customer));
    }
    // if (sale != "All") {
    //   queryConstraints.push(where("sales", "==", sale));
    // }
    if (sale !== "All") {
      const saleValues = getSaleValuesForQuery(sale);

      if (saleValues.length === 1) {
        queryConstraints.push(where("sales", "==", saleValues[0]));
      } else {
        queryConstraints.push(where("sales", "in", saleValues));
      }
    }
    if (status != "All") {
      queryConstraints.push(where("status", "==", status));
    }
    // if (brand != "All") {
    //   if (brand == "Topson") {
    //     queryConstraints.push(
    //       where("productSn", ">=", "LC"),
    //       where("productSn", "<", "LC" + "\uf8ff")
    //     );
    //   } else if (brand == "Philips") {
    //     queryConstraints.push(
    //       where("productSn", ">=", "J"),
    //       where("productSn", "<", "J" + "\uf8ff")
    //     );
    //   }
    // }
    // if (model != "All") {
    //   queryConstraints.push(where("model", "==", model));
    // }
    return query(borrowingsCollectionGroupRef, ...queryConstraints);
  };

  const onOldExport = async (onProgress) => {
    const start = startDate;
    const end = endDate;
    validateExportDates(start, end);

    const node = nodeRef.current.value;
    const customer = customerRef.current.value;
    const sale = saleRef.current.value;
    const activity = activityRef.current.value;
    const status = statusRef.current.value;
    const brand = brandRef.current.value;
    const serialNumber = serialNumberRef.current.value;

    // Usage of the buildQuery function
    let ordersCollectionGroupRef = collection(db, "orders");
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildOldQuery(
      ordersCollectionGroupRef,
      start,
      end,
      node,
      customer,
      sale,
      activity,
      status,
      brand,
    );

    var tempOrders = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      const filteredDocs = docSnap.docs.filter((trial) =>
        matchesSerialNumberFilter(trial.data(), serialNumber),
      );
      tempOrders = await enrichExportOrders(filteredDocs, onProgress);
    }
    // console.log(tempOrders);

    requireExportOrders(tempOrders);
    await createXLSX(tempOrders, start, end, node, customer, sale, activity, status, onProgress);
  };

  const onNewExport = async (onProgress) => {
    const start = newStartDate;
    const end = newEndDate;
    validateExportDates(start, end);

    const node = newNodeRef.current.value;
    const customer = newCustomerRef.current.value;
    const sale = newSaleRef.current.value;
    const status = newStatusRef.current.value;
    const brand = newBrandRef.current.value;
    const serialNumber = newSerialNumberRef.current.value;

    // Usage of the buildQuery function
    let ordersCollectionGroupRef = collection(db, "saleOrders");
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildNewQuery(
      ordersCollectionGroupRef,
      start,
      end,
      node,
      customer,
      sale,
      status,
    );

    var tempOrders;
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
      tempOrders = [];
    } else {
      const filteredDocs = docSnap.docs.filter((d) => {
        if (!matchesSerialNumberFilter(d.data(), serialNumber, true)) return false;
        const items = d.data().items || [];
        if (brand === "All") {
          return true; // Include all items if brand is "All"
        } else {
          return items.some((item) => item.productBrand === brand);
        }
      });

      tempOrders = await enrichExportOrders(filteredDocs, onProgress);
    }

    requireExportOrders(tempOrders);
    await createNewXLSX(tempOrders, start, end, node, customer, sale, status, onProgress);
  };

  const createNewXLSX = async (
    orders,
    start,
    end,
    node,
    customer,
    sale,
    status,
    onProgress,
  ) => {
    // setIsLoading(true);
    const rangeDate = formatDateRangeInThai(start, end);

    var xlsxName = "";
    var sheetName = "";

    var textHeader = "";
    if (node != "All") {
      textHeader = textHeader + node;
      xlsxName = rangeDate + " " + node;
      sheetName = node;

      if (customer != "All") {
        textHeader = textHeader + " - " + customer;
        xlsxName = xlsxName + " - " + customer;
        sheetName = customer;
      }

      if (status != "All") {
        textHeader = textHeader + " " + status;
        xlsxName = xlsxName + " " + status;
        sheetName = sheetName + " " + status;
      } else {
        textHeader = textHeader + " status ทั้งหมด";
        xlsxName = xlsxName + " status ทั้งหมด";
        sheetName = sheetName + " status ทั้งหมด";
      }
    } else {
      if (sale != "") {
        textHeader = rangeDate + " Sale " + sale;
        xlsxName = rangeDate + " Sale " + sale;
        sheetName = sale;
      }
    }

    const headerText = [
      textHeader,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const headers = [
      "ลำดับ",
      "Receipt No.",
      "Receipt Date.",
      "Health Insurance",
      "Sleep Study Order",
      "AHI",
      "โรงพยาบาลผู้ส่งตรวจ",
      "ชื่อ - นามสกุล",
      "รหัสโรงพยาบาล",
      "BDT's HN",
      "Tel",
      "Package",
      "Serial Number",
      "Filter",
      "QTY",
      "Mask",
      "Size",
      "QTY",
      "Sale Representative",
      "Amount",
      "Status",
      "Note",
    ];

    const data = [headerText, headers];
    for (const [index, orderDoc] of orders.entries()) {
      if (index % 50 === 0) {
        onProgress({
          percent: 75 + Math.floor((index / orders.length) * 20),
          message: `Preparing export rows: ${index} / ${orders.length}`,
        });
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
      const row = [];
      const order = orderDoc;
      // const cpapInfo = await getDocs(collection(db,"products"))
      const items = order.items || [];
      var productSn = "";
      var mask = "";
      var maskSize = "";
      var amount = order.totalAmount || 0;
      var filter = "";
      var filterQTY = "";
      var maskQTY = "";
      if (items.length > 0) {
        items.forEach((item) => {
          if (item.productType === "CPAP") {
            productSn = item.productSn || "";
          } else if (item.productType === "Mask") {
            mask = item.productName || "";
            maskSize = item.size;
            maskQTY = item.quantity || "";
          } else if (item.productType === "Filter") {
            filter = item.productName || "";
            filterQTY = item.quantity || "";
          }
        });
      }

      row.push(index + 1);
      row.push(order.receiptNo);
      row.push(
        order.receiptDate.toDate().toLocaleString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }),
      );
      row.push(order.healthInsurance);
      row.push(order.sleepStudyOrder);
      row.push(order.ahi);
      row.push(order.refCustomer);
      row.push(order.firstname + " " + order.lastname);
      row.push(order.refHospital);
      row.push(order.hn);
      row.push(order.mobile);
      row.push(order.salePackage);
      row.push(productSn);
      row.push(filter);
      row.push(filterQTY);
      row.push(mask);
      row.push(maskSize);
      row.push(maskQTY);
      row.push(order.sales);
      row.push(amount);
      row.push(order.status);
      row.push(order.note);
      data.push(row);
    }

    onProgress({ percent: 95, message: "Preparing Excel file..." });
    await new Promise((resolve) => setTimeout(resolve, 0));
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CPAP Sale");
    XLSX.writeFile(wb, `CPAP Sale ${rangeDate}.xlsx`);
    // setIsLoading(false);
  };

  const onOldExportIGC = async (onProgress) => {
    const year = yearRef.current.value;
    const month = monthRef.current.value;
    const startRange = startRef.current.value;
    const endRange = endRef.current.value;
    const node = nodeIGCRef.current.value;
    const customer = customerIGCRef.current.value;
    const serialNumber = serialNumberIGCRef.current.value;

    // Usage of the buildQuery function
    let ordersCollectionGroupRef = collection(db, "orders");
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildOldQueryRange(
      ordersCollectionGroupRef,
      year,
      month,
      startRange,
      endRange,
    );

    const tempOrders = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      docSnap.forEach((trial) => {
        if (!matchesSerialNumberFilter(trial.data(), serialNumber)) return;
        if (node != "All" && customer != "All") {
          if (
            trial.data().nodeRef == node &&
            trial.data().refCustomer == customer
          )
            tempOrders.push(trial.data());
        } else if (node != "All" && customer == "All") {
          if (trial.data().nodeRef == node) tempOrders.push(trial.data());
        } else if (node == "All" && customer != "All") {
          if (trial.data().refCustomer == customer)
            tempOrders.push(trial.data());
        } else if (node == "All" && customer == "All") {
          tempOrders.push(trial.data());
        }
      });
    }
    requireExportOrders(tempOrders);
    await createXLSXByIGC(tempOrders, onProgress);

    // createXLSX(tempOrders, start, end, node, customer, sale, activity, status);
  };

  const onNewExportIGC = async (onProgress) => {
    const year = newYearRef.current.value;
    const month = newMonthRef.current.value;
    const startRange = newStartRef.current.value;
    const endRange = newEndRef.current.value;
    const node = newNodeIGCRef.current.value;
    const customer = newCustomerIGCRef.current.value;
    const serialNumber = newSerialNumberIGCRef.current.value;

    // Usage of the buildQuery function
    let ordersCollectionGroupRef = collection(db, "saleOrders");
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildOldQueryRange(
      ordersCollectionGroupRef,
      year,
      month,
      startRange,
      endRange,
    );

    const tempOrders = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      docSnap.forEach((trial) => {
        if (!matchesSerialNumberFilter(trial.data(), serialNumber, true)) return;
        if (node != "All" && customer != "All") {
          if (
            trial.data().nodeRef == node &&
            trial.data().refCustomer == customer
          )
            tempOrders.push(trial.data());
        } else if (node != "All" && customer == "All") {
          if (trial.data().nodeRef == node) tempOrders.push(trial.data());
        } else if (node == "All" && customer != "All") {
          if (trial.data().refCustomer == customer)
            tempOrders.push(trial.data());
        } else if (node == "All" && customer == "All") {
          tempOrders.push(trial.data());
        }
      });
    }
    requireExportOrders(tempOrders);
    await createNewXLSXByIGC(tempOrders, onProgress);

    // createXLSX(tempOrders, start, end, node, customer, sale, activity, status);
  };

  const createNewXLSXByIGC = async (orders, onProgress) => {
    // setIsLoading(true);

    var xlsxName = "";
    var sheetName = "";
    var textHeader = "";

    var node = nodeIGCRef.current.value;
    var customer = customerIGCRef.current.value;

    if (node != "All") {
      textHeader = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      xlsxName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      sheetName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      if (customer != "All") {
        textHeader = textHeader + " - " + customer;
        xlsxName = xlsxName + " - " + customer;
        sheetName = sheetName + " - " + customer;
      }
    } else {
      textHeader = `CPAP Sale IGC ${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
      xlsxName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
      sheetName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
    }
    const headerText = [
      textHeader,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const headers = [
      "ลำดับ",
      "Receipt No.",
      "Receipt Date.",
      "โรงพยาบาลผู้ส่งตรวจ",
      "ชื่อ - นามสกุล",
      "รหัสโรงพยาบาล",
      "BDT's HN",
      "Package",
      "Serial Number",
      "Filter",
      "QTY",
      "Mask",
      "Size",
      "QTY",
      "Sale Representative",
      "Amount",
      "Status",
      "Note",
    ];

    const data = [headerText, headers];
    for (const [index, orderDoc] of orders.entries()) {
      if (index % 50 === 0) {
        onProgress({
          percent: 75 + Math.floor((index / orders.length) * 20),
          message: `Preparing export rows: ${index} / ${orders.length}`,
        });
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
      const row = [];
      const order = orderDoc;
      // const cpapInfo = await getDocs(collection(db,"products"))
      const items = order.items || [];
      var productSn = "";
      var mask = "";
      var maskSize = "";
      var amount = order.totalAmount || 0;
      var filter = "";
      var filterQTY = "";
      var maskQTY = "";
      if (items.length > 0) {
        items.forEach((item) => {
          if (item.productType === "CPAP") {
            productSn = item.productSn || "";
          } else if (item.productType === "Mask") {
            mask = item.productName || "";
            maskSize = item.size;
            maskQTY = item.quantity || "";
          } else if (item.productType === "Filter") {
            filter = item.productName || "";
            filterQTY = item.quantity || "";
          }
        });
      }
      row.push(index + 1);
      row.push(order.receiptNo);
      row.push(
        order.receiptDate.toDate().toLocaleString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }),
      );
      row.push(order.refCustomer);
      row.push(order.firstname + " " + order.lastname);
      row.push(order.refHospital);
      row.push(order.hn);
      row.push(order.salePackage);
      row.push(productSn);
      row.push(filter);
      row.push(filterQTY);
      row.push(mask);
      row.push(maskSize);
      row.push(maskQTY);
      row.push(order.sales);
      row.push(amount);
      row.push(order.status);
      row.push(order.note);

      data.push(row);
    }

    onProgress({ percent: 95, message: "Preparing Excel file..." });
    await new Promise((resolve) => setTimeout(resolve, 0));
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CPAP Sale");
    XLSX.writeFile(wb, `CPAP Sale ${xlsxName}.xlsx`);
    // setIsLoading(false);
  };

  const buildOldQueryRange = (
    collectionRef,
    year,
    month,
    startRange,
    endRange,
  ) => {
    const prefix = `IGC${year}${month}`;
    const startCode = `${prefix}${startRange}`;
    const endCode = `${prefix}${endRange}`;

    return query(
      collectionRef,
      where("receiptNo", ">=", startCode),
      where("receiptNo", "<=", endCode),
      orderBy("receiptNo"),
    );
  };

  const formatDateRangeInThai = (startDateTimestamp, endDateTimestamp) => {
    const startDate = new Date(startDateTimestamp);
    const endDate = new Date(endDateTimestamp);

    const options = { year: "numeric", month: "long", day: "numeric" };
    const thaiFormatter = new Intl.DateTimeFormat("th-TH", options);

    const startDay = startDate.getDate();
    const startMonth = startDate.toLocaleString("th-TH", { month: "long" });
    const startYear = startDate.getFullYear();

    const endDay = endDate.getDate();
    const endMonth = endDate.toLocaleString("th-TH", { month: "long" });
    const endYear = endDate.getFullYear();

    if (startYear === endYear) {
      if (startMonth === endMonth) {
        return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
      }
      return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
    }

    const formattedStartDate = thaiFormatter.format(startDate);
    const formattedEndDate = thaiFormatter.format(endDate);

    return `${formattedStartDate} - ${formattedEndDate}`;
  };

  const createXLSX = async (
    orders,
    start,
    end,
    node,
    customer,
    sale,
    activity,
    status,
    onProgress,
  ) => {
    // setIsLoading(true);
    const rangeDate = formatDateRangeInThai(start, end);

    var xlsxName = "";
    var sheetName = "";

    var textHeader = "";
    if (node != "All") {
      textHeader = textHeader + node;
      xlsxName = rangeDate + " " + node;
      sheetName = node;

      if (customer != "All") {
        textHeader = textHeader + " - " + customer;
        xlsxName = xlsxName + " - " + customer;
        sheetName = customer;
      }
      if (activity != "All") {
        textHeader = textHeader + " " + activity;
        xlsxName = xlsxName + " " + activity;
        sheetName = sheetName + " " + activity;
      } else {
        textHeader = textHeader + " activity ทั้งหมด";
        xlsxName = xlsxName + " activity ทั้งหมด";
        sheetName = sheetName + " activity ทั้งหมด";
      }
      if (status != "All") {
        textHeader = textHeader + " " + status;
        xlsxName = xlsxName + " " + status;
        sheetName = sheetName + " " + status;
      } else {
        textHeader = textHeader + " status ทั้งหมด";
        xlsxName = xlsxName + " status ทั้งหมด";
        sheetName = sheetName + " status ทั้งหมด";
      }
    } else {
      if (sale != "") {
        textHeader = rangeDate + " Sale " + sale;
        xlsxName = rangeDate + " Sale " + sale;
        sheetName = sale;
      }
    }

    const headerText = [
      textHeader,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const headers = [
      "ลำดับ",
      "Receipt No.",
      "Receipt Date.",
      "Health Insurance",
      "Sleep Study Order",
      "AHI",
      "โรงพยาบาลผู้ส่งตรวจ",
      "ชื่อ - นามสกุล",
      "รหัสโรงพยาบาล",
      "BDT's HN",
      "Tel",
      "Serial Number",
      "Package",
      "Mask",
      "Size",
      "Sale Representative",
      "Amount",
      "Status",
      "Note",
    ];

    const data = [headerText, headers];
    for (const [index, orderDoc] of orders.entries()) {
      if (index % 50 === 0) {
        onProgress({
          percent: 75 + Math.floor((index / orders.length) * 20),
          message: `Preparing export rows: ${index} / ${orders.length}`,
        });
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
      const row = [];
      const order = orderDoc;
      // const cpapInfo = await getDocs(collection(db,"products"))

      row.push(index + 1);
      row.push(order.receiptNo);
      row.push(
        order.receiptDate.toDate().toLocaleString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }),
      );
      row.push(order.healthInsurance);
      row.push(order.sleepStudyOrder);
      row.push(order.ahi);
      row.push(order.refCustomer);
      row.push(order.firstname + " " + order.lastname);
      row.push(order.refHospital);
      row.push(order.hn);
      row.push(order.mobile);
      row.push(order.productSn);
      row.push(order.salePackage);
      row.push(order.mask);
      row.push(order.maskSize);
      row.push(order.sales);
      row.push(order.amount);
      row.push(order.status);
      row.push(order.note);
      data.push(row);
    }

    onProgress({ percent: 95, message: "Preparing Excel file..." });
    await new Promise((resolve) => setTimeout(resolve, 0));
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CPAP Sale");
    XLSX.writeFile(wb, `CPAP Sale ${rangeDate}.xlsx`);
    // setIsLoading(false);
  };

  const createXLSXByIGC = async (orders, onProgress) => {
    // setIsLoading(true);

    var xlsxName = "";
    var sheetName = "";
    var textHeader = "";

    var node = nodeIGCRef.current.value;
    var customer = customerIGCRef.current.value;

    if (node != "All") {
      textHeader = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      xlsxName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      sheetName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value} ${node}`;
      if (customer != "All") {
        textHeader = textHeader + " - " + customer;
        xlsxName = xlsxName + " - " + customer;
        sheetName = sheetName + " - " + customer;
      }
    } else {
      textHeader = `CPAP Sale IGC ${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
      xlsxName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
      sheetName = `IGC${yearRef.current.value}${monthRef.current.value} ${startRef.current.value}-${endRef.current.value}`;
    }
    const headerText = [
      textHeader,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const headers = [
      "ลำดับ",
      "Receipt No.",
      "Receipt Date.",
      "โรงพยาบาลผู้ส่งตรวจ",
      "ชื่อ - นามสกุล",
      "รหัสโรงพยาบาล",
      "BDT's HN",
      "Serial Number",
      "Package",
      "Mask",
      "Size",
      "Sale Representative",
      "Amount",
      "Status",
      "Note",
    ];

    const data = [headerText, headers];
    for (const [index, orderDoc] of orders.entries()) {
      if (index % 50 === 0) {
        onProgress({
          percent: 75 + Math.floor((index / orders.length) * 20),
          message: `Preparing export rows: ${index} / ${orders.length}`,
        });
        await new Promise((resolve) => setTimeout(resolve, 0));
      }
      const row = [];
      const order = orderDoc;
      // const cpapInfo = await getDocs(collection(db,"products"))

      row.push(index + 1);
      row.push(order.receiptNo);
      row.push(
        order.receiptDate.toDate().toLocaleString("th-TH", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }),
      );
      row.push(order.refCustomer);
      row.push(order.firstname + " " + order.lastname);
      row.push(order.refHospital);
      row.push(order.hn);
      row.push(order.productSn);
      row.push(order.salePackage);
      row.push(order.mask);
      row.push(order.maskSize);
      row.push(order.sales);
      row.push(order.amount);
      row.push(order.status);
      row.push(order.note);

      data.push(row);
    }

    onProgress({ percent: 95, message: "Preparing Excel file..." });
    await new Promise((resolve) => setTimeout(resolve, 0));
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CPAP Sale");
    XLSX.writeFile(wb, `CPAP Sale ${xlsxName}.xlsx`);
    // setIsLoading(false);
  };

  const CustomerList = (nodename) => {
    const index = nodeList.indexOf(nodename);
    return ["All", ...customerAllList[index]];
  };

  const validateRange = (value) => {
    return (
      /^\d{3}$/.test(value) && parseInt(value) >= 1 && parseInt(value) <= 999
    );
  };

  return (
    <>
      {exportError && <div className="alert alert-warning" role="alert">{exportError}</div>}
      <ExportProgress progress={exportProgress} isExporting={isLoading} label="CPAP Sale" />
      <fieldset disabled={isLoading}>
          <div className="col-lg-12 mb-5">
            <b>NEW CPAP SALE (~AUG 2025)</b>
            <div className="row">
              <div className="col-xl-6 col-lg-6 mt-4">
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label">
                    {"Range Date"}
                    <span className="text-danger"></span>
                  </label>
                  <div className="row ml-1">
                    <div className="col-lg-3">
                      <DatePicker
                        disabled={isLoading}
                        className="form-control"
                        selected={newStartDate}
                        onChange={(date) =>
                          setNewStartDate(date ? date.setHours(0, 0, 0, 0) : null)
                        }
                        selectsStart
                        startDate={newStartDate}
                        endDate={newEndDate}
                        minDate={null}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/MM/yyyy"
                      // todayButton={true}
                      />
                    </div>
                    <div className="mt-3">-</div>
                    <div className="col-lg-3">
                      <DatePicker
                        disabled={isLoading}
                        className="form-control"
                        selected={newEndDate}
                        onChange={(date) =>
                          setNewEndDate(date ? date.setHours(23, 59, 59, 999) : null)
                        }
                        selectsEnd
                        startDate={newStartDate}
                        endDate={newEndDate}
                        minDate={newStartDate}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/MM/yyyy"
                        todayBtn={true}
                      />
                    </div>
                  </div>
                </div>
                <PatientDropDownForm
                  title="Node"
                  id="node-sale"
                  refvalue={newNodeRef}
                  // selected={currentBooking.extendedProps.node}
                  options={nodeList}
                  onChange={(e) => {
                    setNewCustomerList(CustomerList(e.target.value));
                  }}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Customer"
                  id="customer-sale"
                  refvalue={newCustomerRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={newCustomerList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Status"
                  id="status-sale"
                  refvalue={newStatusRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={statusList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Activity"
                  id="activity-sale"
                  refvalue={newActivityRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={activityList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Sale"
                  id="sale-sale"
                  refvalue={newSaleRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={saleList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Brand"
                  id="brand-sale"
                  refvalue={newBrandRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={brandList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Serial Number"
                  id="new-sale-serial-number"
                  htmlFor="new-sale-serial-number"
                  refvalue={newSerialNumberRef}
                  selected="All"
                  options={serialNumberOptions}
                ></PatientDropDownForm>
                <Button onClick={() => runExport(onNewExport)} disabled={isLoading}>
                  {isLoading ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
                </Button>
              </div>

              <div className="col-xl-6 col-lg-6 mt-4">
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label">
                    {"IGC"}
                    <span className="text-danger"></span>
                  </label>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Year in TH (YY)
                  </label>
                  <div className="col-lg-5">
                    <input
                      type="text"
                      className="form-control"
                      id="year"
                      name="year"
                      placeholder=""
                      ref={newYearRef}
                      defaultValue={String(
                        new Date().getFullYear() + 543,
                      ).slice(-2)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Month (01-12)
                  </label>
                  <div className="col-lg-5">
                    <input
                      type="text"
                      className="form-control"
                      id="month"
                      name="month"
                      placeholder=""
                      ref={newMonthRef}
                      defaultValue={String(new Date().getMonth() + 1).padStart(
                        2,
                        "0",
                      )}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="range-start"
                  >
                    Range (001 - 999)
                  </label>
                  <div className="col-lg-2">
                    <input
                      type="text"
                      className="form-control"
                      id="range-start"
                      name="range-start"
                      ref={newStartRef}
                      defaultValue="001"
                      maxLength={3}
                      pattern="\d{3}"
                      placeholder="001"
                    />
                  </div>
                  {"-"}
                  <div className="col-lg-2">
                    <input
                      type="text"
                      className="form-control"
                      id="range-end"
                      name="range-end"
                      ref={newEndRef}
                      defaultValue="999"
                      maxLength={3}
                      pattern="\d{3}"
                      placeholder="999"
                    />
                  </div>
                </div>

                <PatientDropDownForm
                  title="Node"
                  id="node-sale"
                  refvalue={newNodeIGCRef}
                  options={nodeList}
                  onChange={(e) => {
                    setNewCustomerList(CustomerList(e.target.value));
                  }}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Customer"
                  id="customer-sale"
                  refvalue={newCustomerIGCRef}
                  options={customerList}
                ></PatientDropDownForm>
                {/* <PatientDropDownForm
                title="Status"
                id="status-sale"
                refvalue={statusRef}
                options={statusList}
              ></PatientDropDownForm> */}
                {/* <PatientDropDownForm
                title="Activity"
                id="activity-sale"
                refvalue={activityRef}
                options={activityList}
              ></PatientDropDownForm>
              <PatientDropDownForm
                title="Sale"
                id="sale-sale"
                refvalue={saleRef}
                options={saleList}
              ></PatientDropDownForm> */}
                <PatientDropDownForm
                  title="Serial Number"
                  id="new-sale-igc-serial-number"
                  htmlFor="new-sale-igc-serial-number"
                  refvalue={newSerialNumberIGCRef}
                  selected="All"
                  options={serialNumberOptions}
                ></PatientDropDownForm>
                <Button onClick={() => runExport(onNewExportIGC)} disabled={isLoading}>
                  {isLoading ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
                </Button>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mt-5">
            <b>OLD CPAP SALE</b>
            <div className="row">
              <div className="col-xl-6 col-lg-6 mt-4">
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label">
                    {"Range Date"}
                    <span className="text-danger"></span>
                  </label>
                  <div className="row ml-1">
                    <div className="col-lg-3">
                      <DatePicker
                        disabled={isLoading}
                        className="form-control"
                        selected={startDate}
                        onChange={(date) =>
                          setStartDate(date ? date.setHours(0, 0, 0, 0) : null)
                        }
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        minDate={null}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/MM/yyyy"
                      // todayButton={true}
                      />
                    </div>
                    <div className="mt-3">-</div>
                    <div className="col-lg-3">
                      <DatePicker
                        disabled={isLoading}
                        className="form-control"
                        selected={endDate}
                        onChange={(date) =>
                          setEndDate(date ? date.setHours(23, 59, 59, 999) : null)
                        }
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/MM/yyyy"
                        todayBtn={true}
                      />
                    </div>
                  </div>
                </div>
                <PatientDropDownForm
                  title="Node"
                  id="node-sale"
                  refvalue={nodeRef}
                  // selected={currentBooking.extendedProps.node}
                  options={nodeList}
                  onChange={(e) => {
                    setCustomerList(CustomerList(e.target.value));
                  }}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Customer"
                  id="customer-sale"
                  refvalue={customerRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={customerList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Status"
                  id="status-sale"
                  refvalue={statusRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={statusList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Activity"
                  id="activity-sale"
                  refvalue={activityRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={activityList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Sale"
                  id="sale-sale"
                  refvalue={saleRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={saleList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Brand"
                  id="brand-sale"
                  refvalue={brandRef}
                  // selected={currentBooking.extendedProps.customer}
                  options={brandList}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Serial Number"
                  id="old-sale-serial-number"
                  htmlFor="old-sale-serial-number"
                  refvalue={serialNumberRef}
                  selected="All"
                  options={serialNumberOptions}
                ></PatientDropDownForm>
                <Button onClick={() => runExport(onOldExport)} disabled={isLoading}>
                  {isLoading ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
                </Button>
              </div>

              <div className="col-xl-6 col-lg-6 mt-4">
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label">
                    {"IGC"}
                    <span className="text-danger"></span>
                  </label>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Year in TH (YY)
                  </label>
                  <div className="col-lg-5">
                    <input
                      type="text"
                      className="form-control"
                      id="year"
                      name="year"
                      placeholder=""
                      ref={yearRef}
                      defaultValue={String(
                        new Date().getFullYear() + 543,
                      ).slice(-2)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Month (01-12)
                  </label>
                  <div className="col-lg-5">
                    <input
                      type="text"
                      className="form-control"
                      id="month"
                      name="month"
                      placeholder=""
                      ref={monthRef}
                      defaultValue={String(new Date().getMonth() + 1).padStart(
                        2,
                        "0",
                      )}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="range-start"
                  >
                    Range (001 - 999)
                  </label>
                  <div className="col-lg-2">
                    <input
                      type="text"
                      className="form-control"
                      id="range-start"
                      name="range-start"
                      ref={startRef}
                      defaultValue="001"
                      maxLength={3}
                      pattern="\d{3}"
                      placeholder="001"
                    />
                  </div>
                  {"-"}
                  <div className="col-lg-2">
                    <input
                      type="text"
                      className="form-control"
                      id="range-end"
                      name="range-end"
                      ref={endRef}
                      defaultValue="999"
                      maxLength={3}
                      pattern="\d{3}"
                      placeholder="999"
                    />
                  </div>
                </div>

                <PatientDropDownForm
                  title="Node"
                  id="node-sale"
                  refvalue={nodeIGCRef}
                  options={nodeList}
                  onChange={(e) => {
                    setCustomerList(CustomerList(e.target.value));
                  }}
                ></PatientDropDownForm>
                <PatientDropDownForm
                  title="Customer"
                  id="customer-sale"
                  refvalue={customerIGCRef}
                  options={customerList}
                ></PatientDropDownForm>
                {/* <PatientDropDownForm
                title="Status"
                id="status-sale"
                refvalue={statusRef}
                options={statusList}
              ></PatientDropDownForm> */}
                {/* <PatientDropDownForm
                title="Activity"
                id="activity-sale"
                refvalue={activityRef}
                options={activityList}
              ></PatientDropDownForm>
              <PatientDropDownForm
                title="Sale"
                id="sale-sale"
                refvalue={saleRef}
                options={saleList}
              ></PatientDropDownForm> */}
                <PatientDropDownForm
                  title="Serial Number"
                  id="old-sale-igc-serial-number"
                  htmlFor="old-sale-igc-serial-number"
                  refvalue={serialNumberIGCRef}
                  selected="All"
                  options={serialNumberOptions}
                ></PatientDropDownForm>
                <Button onClick={() => runExport(onOldExportIGC)} disabled={isLoading}>
                  {isLoading ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
                </Button>
              </div>
            </div>
          </div>
      </fieldset>
    </>
  );
};

export default CPAPSale;
